import { render, staticRenderFns } from "./communityStatistics.vue?vue&type=template&id=e8feef52&scoped=true&"
import script from "./communityStatistics.vue?vue&type=script&lang=js&"
export * from "./communityStatistics.vue?vue&type=script&lang=js&"
import style0 from "./communityStatistics.vue?vue&type=style&index=0&id=e8feef52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8feef52",
  null
  
)

export default component.exports